export const GET_TEAM_MEMBERS = '[Teams] Get team members';
export const GET_TEAM_MEMBERS_SUCCESS = '[Teams] Get teams Success';
export const GET_TEAM_MEMBERS_ERROR = '[Teams] Get teams Error';

export const UPDATE_TEAM_MEMBER = '[Teams] Update team member';
export const UPDATE_TEAM_MEMBER_SUCCESS = '[Teams] Update team member Success';
export const UPDATE_TEAM_MEMBER_ERROR = '[Teams] Update team member Error';

export const CREATE_TEAM_MEMBER = '[Teams] Create team member';
export const CREATE_TEAM_MEMBER_SUCCESS = '[Teams] Create team member Success';
export const CREATE_TEAM_MEMBER_ERROR = '[Teams] Create team member Error';

export const REMOVE_TEAM_MEMBER = '[Teams] Remove team member';
export const REMOVE_TEAM_MEMBER_SUCCESS = '[Teams] Remove team member Success';
export const REMOVE_TEAM_MEMBER_ERROR = '[Teams] Remove team member Error';
